module.exports = __webpack_public_path__ + "img/exam-stat-score@1.5x.ea6df4cd.png";